import { createAction } from "@reduxjs/toolkit";

export const resetReduxStore = createAction("resetReduxStore");
